import { Outlet } from 'react-router-dom'
import NavigationListener from '../common/Navigation'

const ErrorLayout: React.FC = () => {
  return (
    <div className="flex flex-col h-screen">
      <NavigationListener />
      <Outlet />
    </div>
  )
}

export default ErrorLayout
